'use strict';

window.console || (window.console = {
	log: function log() {}
});
var FUNCTIONS = window.FUNCTIONS || null;
var cssua = window.cssua || null;

(function ($) {
	var siteName = 'aderans-rn';
	var a = 'is-active';
	var f = 'is-fixed';
	var v = 'is-visible';
	var h = 'is-hidden';
	var slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.0\\.|192\\.168\\.11\\.|192\\.168\\.1\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
			//spのみ
			if (FUNCTIONS.va.window.width < 768) {
				var $switch = $('.js-sp-toggle');

				$switch.on('click', function () {
					$(this).toggleClass(a);
					$(this).next('.js-sp-toggleBlock').stop().slideToggle(slideSpeed);
				});
			}
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (event) {
				var speed = 1200;
				if (/#/.test(event.currentTarget.href)) {
					scrollToObject(event.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos -= 60;
					} else {
						pos -= 60;
					}
				}

				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				// var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				// var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
			});
		},
		headerMenu: function headerMenu() {
			var $header = $('.header-menu');
			var $menu = $('.js-header-menu');
			var $menubtn = $('.js-header-menu-btn');
			var $menucontent = $('.js-header-menu-content');
			var $menuclosebtn = $('.js-header-close-btn');
			var scrollTopNow;

			//pc・sp共通ハンバーガーメニュー
			$menu.on('click', function () {
				scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;

				$menubtn.addClass(a);
				$menucontent.addClass(a);
				$header.addClass(a);
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			});
			$menuclosebtn.on('click', function () {
				$menubtn.removeClass(a);
				$menucontent.removeClass(a);
				$header.removeClass(a);
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);

				$(window).scrollTop(scrollTopNow);
			});
			if (location.pathname === '/ladies/product/') {
				$('a[href^="/ladies/product/#"]').on('click', function (event) {
					$menubtn.removeClass(a);
					$menucontent.removeClass(a);
					$header.removeClass(a);
					$('.container').css({
						position: 'static'
					});
					$('body').removeClass(f);

					setTimeout(function () {
						var hash = '#' + event.currentTarget.href.split('#')[1];
						var pos = $(hash).offset().top;
						pos -= 60;

						$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
					}, 1000);
				});
			}
		},
		headerScroll: function headerScroll() {
			if ($('.idx').length && FUNCTIONS.va.window.width > 767) {
				//idxのpc時
				var headerPos = $('.js-mainVisual').innerHeight();

				$('.header').css('top', headerPos);

				$(window).scroll(function () {
					var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
					headerPos = $('.js-mainVisual').innerHeight();
					if (scrollTop > headerPos) {
						$('.header').addClass(f);
					} else if ($('.header').hasClass(f)) {
						$('.header').removeClass(f);
					}
				});
			} else if (FUNCTIONS.va.window.width < 769 && $('.js-mainVisual').length) {
				//スマホ時(メインビジュアルがあるページ)共通
				$('.header').addClass(v);
				$(window).scroll(function () {
					var mainHeight = $('.js-mainVisual').innerHeight() + 120;
					var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
					console.log(mainHeight);
					console.log(scrollTop);
					if (scrollTop > mainHeight) {
						$('.header').addClass(f);
					} else if ($('.header').hasClass(f)) {
						$('.header').removeClass(f);
					}
				});
			} else {
				$(window).scroll(function () {
					var headerHeight = $('.header').innerHeight();
					var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

					if (scrollTop > headerHeight) {
						$('.header').addClass(f);
					} else if ($('.header').hasClass(f)) {
						$('.header').removeClass(f);
					}
				});
			}
		},
		yahooSearch: function yahooSearch() {
			//#srchBox
			var sb = document.getElementById('srchBox');
			if (sb && sb.className == 'watermark') {
				var si = document.getElementById('srchInput');
				var f = function f() {
					si.className = 'nomark';
				};
				var b = function b() {
					if (si.value == '') {
						si.className = '';
					}
				};
				si.onfocus = f;
				si.onblur = b;
				if (!/[&?]p=[^&]/.test(location.search)) {
					b();
				} else {
					f();
				}
			}
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.pageTop();
			_this.headerMenu();
			_this.headerScroll();
			// _this.yahooSearch();
		}
	};

	$(function () {
		return FUNCTIONS.loadDelayScript();
	});
})(window.jQuery);
// easeScrollHash()
if (location.hash) {
	var hash = location.hash;
	var map = location.pathname.split('/')[1];
	$(window).on('load', function () {
		$('html, body').css('transition', 'all 0.3s ease');
		$('html, body').css('opacity', '0');
		$('html, body').stop().animate({ scrollTop: 0 }, 0, 'easeOutExpo');
		setTimeout(function () {
			$('html, body').css('opacity', '1');

			var _hash = '#' + hash.split('#')[1];
			var pos = $(_hash).offset().top;

			if (hash !== '#pagetop') {
				pos -= 60;
			}

			$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
		}, 300);
	});
}